module.exports = __webpack_public_path__ + "media/components/country-flag/static/ad-1900a39e5d7267f20dd90047e5702d35.svg";